import cabecaPolidora from '../../../assets/images/products/cabeca-polidora.png';
import { ReactComponent as MaintenanceIcon } from '../../../assets/svg/maintenance-icon-1.svg';
import { ReactComponent as ProductIcon } from '../../../assets/svg/product-icon-1.svg';
import { ReactComponent as ServiceIcon } from '../../../assets/svg/service-icon-1.svg';
import Container from '../../../components/container';

export default function Purpose() {

	const missionSection = (
		<div>
			<ProductIcon className={'size-16 float-left mr-4'}/>
			<span className={'text-xl'}>Missão</span>
			<p className={'roboto pl-20 pt-2'}>
				Desenvolver soluções inovadoras na área mecânica, comprometendo-se em superar as expectativas de nossos clientes e colaboradores.
			</p>
		</div>
	);

	const visionSection = (
		<div>
			<ServiceIcon className={'size-16 float-left mr-4'}/>
			<span className={'text-xl'}>Visão</span>
			<p className={'roboto pl-20 pt-2'}>
				Tornar-se referencia no segmento, se destacando pela qualidade, agilidade e competitividade dos trabalhos técnicos entregues.
			</p>
		</div>
	);

	const valuesSection = (
		<div>
			<MaintenanceIcon className={'size-16 float-left mr-4'}/>
			<span className={'text-xl'}>Valores</span>
			<p className={'roboto pl-20 pt-2'}>
				Ética, inovação, transparência, honestidade, responsabilidade e dedicação.
			</p>
		</div>
	);

	return (
		<Container>
			<div className={'grid grid-cols-1 sm:grid-cols-2 gap-8'}>
				<div className={'space-y-2'}>
					<div>
						<div className={'text-xl sm:text-3xl'}>Nosso propósito</div>
						<div className={'py-3 roboto text-base sm:text-lg'}>
							A FAST atua em todo território nacional, especializada em:
						</div>
					</div>

					<div className={'space-y-8'}>
						{missionSection}
						{visionSection}
						{valuesSection}
					</div>
				</div>

				<div className={'w-full max-w-lg relative justify-center sm:justify-end'}>
					<img src={cabecaPolidora} alt={'Cabeça Polidora'} className={'sm:-mb-32 w-full'}/>
				</div>
			</div>
		</Container>
	);
}